export const VIEWS = {
  DEFAULT: "default",
  VARS: "vars",
  GROUP: "group",
  PARALEL: "paralel"
};
